import moment from "moment";
import { formatDateRestore, currentDate } from "@/utils/date";

const required = value => !!value || "Campo obrigatório";

const maxCurrentDate = date =>
  new Date(formatDateRestore(date)) <= new Date(currentDate()) ||
  "Precisa ser menor ou igual a data atual";

const validDate = (value, { acceptEmptyData } = false) => {
  const isValidDate =
    value?.length === 10 &&
    moment(formatDateRestore(value), "YYYY-MM-DD").isValid();

  return isValidDate || (acceptEmptyData && !value) || "Data inválida";
};

const maxDatePrimeiroVencimento = (startDate, endDate) =>
  new Date(endDate) <= new Date(startDate) ||
  "Data do primeiro vencimento inválida";

const maxQtdParcelas = (
  valorMaximoPorParcela,
  qtd,
  valorFatura,
  qtdMaximaPermitida
) => {
  const valorMaxParcela = valorMaximoPorParcela?.replace(",", ".");
  const valorFaturaParcelar = valorFatura?.replace(",", ".");

  return (
    (parseFloat(valorFaturaParcelar) / qtd >= parseFloat(valorMaxParcela) &&
      qtd <= qtdMaximaPermitida) ||
    "Quantidade de parcelas não permitida"
  );
};

const passwordValidation = value => {
  if (value.length < 8) {
    return "A senha deve conter pelo menos 8 caracteres";
  }

  if (!/[^A-Za-z\d]/.test(value)) {
    return "A senha deve conter ao menos um caractere especial.";
  }

  if (!/\d/.test(value)) {
    return "A senha deve conter ao menos um número.";
  }

  if (!/[A-Z]/.test(value)) {
    return "A senha deve conter ao menos uma letra maiúscula.";
  }

  if (!/[a-z]/.test(value)) {
    return "A senha deve conter ao menos uma letra minúscula.";
  }
};

export {
  required,
  maxCurrentDate,
  maxDatePrimeiroVencimento,
  maxQtdParcelas,
  passwordValidation,
  validDate
};
